import { unwrapResponse } from "@/api/utils/NetworkError"
import { env } from "@/env"
import type { Kit } from "@/types"

import { authFetch } from "./utils"

// TODO: Migrate to client

export async function getKits() {
  const res = await authFetch(`${env.VITE_API2_URL}/education/v2/kits`)
  const list = await unwrapResponse<Kit[]>(res)
  return list
}
